export default __webpack_public_path__ + "static/media/PhoneReadyIcon.17eec0ac.svg";